import React, { useState } from "react";
import { StyleSheet, View, Image, TextInput, TouchableOpacity, FlatList, useWindowDimensions, ScrollView } from "react-native";
import config from "../config/config";
import IconTouchable from "../components/IconTouchable";
import useApi from "../hooks/useApi";
import productsApi from "../api/products";
import Screen from "../components/Screen";
import AppText from "../components/AppText";
import useUser from "../hooks/useUser";
import { useFonts } from "expo-font";
import Icon from "../components/Icon";
import ListingCard from "../components/ListingCard";
import Container from "../components/Container";
import usePopUp from "../hooks/usePopUp";
import { callNumber, sendEmail, sendWhatsapp } from "../utility/contactUser";

function WelcomeScreen({ navigation }) {
    const { user, logOut } = useUser();
    const { setMessage } = usePopUp();

    const window = useWindowDimensions();

    const [registration, setRegistration] = useState();
    const [vehicle, setVehicle] = useState(false);
    const [products, setProducts] = useState(false);

    const validateVehicleApi = useApi(productsApi.validateVehicle);
    const getMatchingProductsApi = useApi(productsApi.getMatching);

    const handleSetRegistration = async () => {
        setVehicle(false);
        const response = await validateVehicleApi.request(registration);
        if (response.ok) {
            setVehicle(response.data);
            setProducts(false);
        } else {
            setMessage("Unable to find vehicle");
        }
    };

    const handleVehicleConfirmed = async () => {
        const response = await getMatchingProductsApi.request(vehicle.engineCode);
        if (response.ok) {
            if (response.data.length > 0) {
                setProducts(response.data);
            } else {
                setMessage("Please browse the store using the store button above");
            }
        } else {
            setMessage("Please browse the store using the store button above");
        }
    };

    const [loaded] = useFonts({
        UKNumberPlate: require("../assets/fonts/UKNumberPlate.ttf"),
    });

    if (!loaded) {
        return null;
    }

    return (
        <Screen
            loading={validateVehicleApi.loading}
            leftIconComponent={<IconTouchable name={"store"} text={"Store"} onPress={() => navigation.navigate("Store")} />}
            midRightIconComponent={<IconTouchable name={"whatsapp"} text={"Whatsapp"} onPress={() => sendWhatsapp({ phone: "07398616294" }, "")} />}
            midLeftIconComponent={<IconTouchable name={"phone"} text={"Call"} onPress={() => callNumber({ phone: "07398616294" })} />}
            rightIconComponent={
                user.type == "admin" ? (
                    <IconTouchable name={"logout"} text={"Logout"} onPress={() => logOut()} />
                ) : (
                    <IconTouchable name={"login"} text={"Login"} onPress={() => navigation.navigate("Login")} />
                )
            }
        >
            <ScrollView>
                <View style={{ alignSelf: "center" }}>
                    <Image source={require("../assets/logo.jpeg")} resizeMode={"contain"} style={{ borderRadius: 25, height: 100, width: 293 }} />
                </View>
                <View style={{ alignItems: "center", flexDirection: "column" }}>
                    <View style={{ flexDirection: "row", alignItems: "center" }}>
                        <Icon name={"email"} backgroundColor={"transparent"} />
                        <AppText
                            onPress={() => sendEmail({ email: "lee@autosparesdirect.uk" }, "")}
                            style={{ fontWeight: "bold", color: config.colors.white }}
                        >
                            lee@autosparesdirect.uk
                        </AppText>
                    </View>
                    <View style={{ paddingLeft: 10, flexDirection: "row", alignItems: "center" }}>
                        <Icon name={"phone"} backgroundColor={"transparent"} />
                        <AppText onPress={() => callNumber({ phone: "07398616294" })} style={{ fontWeight: "bold", color: config.colors.white }}>
                            07398616294
                        </AppText>
                    </View>
                    <AppText style={{ fontWeight: "bold", color: config.colors.white }}>
                        Browse our Store or Enter your vehicle registration to find matching parts
                    </AppText>
                    <View style={{ flexDirection: "row" }}>
                        <View style={{ marginTop: 30, marginBottom: 10, flexDirection: "row", borderWidth: 4, borderColor: config.colors.tertiary }}>
                            <View style={{ backgroundColor: config.colors.regPlateBlue, justifyContent: "center", paddingLeft: 3, paddingRight: 6 }}>
                                <AppText style={{ fontFamily: "UKNumberPlate", fontSize: 45, color: config.colors.white }}>GB</AppText>
                            </View>
                            <View style={{ backgroundColor: config.colors.regPlate, justifyContent: "center" }}>
                                <TextInput
                                    maxLength={8}
                                    style={{ fontFamily: "UKNumberPlate", fontSize: 45, color: "#000", width: 225, paddingLeft: 10 }}
                                    placeholder={"Enter Reg"}
                                    onChangeText={(text) => setRegistration(text)}
                                />
                            </View>
                        </View>
                    </View>

                    {registration ? (
                        <TouchableOpacity
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                paddingLeft: 20,
                                borderWidth: 4,
                                borderColor: config.colors.regPlateBlue,
                                backgroundColor: config.colors.regPlate,
                                marginBottom: 10,
                                borderRadius: 25,
                            }}
                            onPress={() => handleSetRegistration()}
                        >
                            <AppText style={{}}>Find Vehicle</AppText>
                            <Icon name="magnify" size={50} backgroundColor={config.colors.regPlate} iconColor={config.colors.regPlateBlue} />
                        </TouchableOpacity>
                    ) : null}

                    {vehicle && !products && (
                        <View style={{ width: 320 }}>
                            <View
                                style={{ borderWidth: 4, borderColor: config.colors.tertiary, backgroundColor: config.colors.regPlate, padding: 5 }}
                            >
                                <AppText style={{ fontFamily: "UKNumberPlate", fontSize: 20, lineHeight: 30 }}>
                                    {vehicle.year + " " + vehicle.make + " " + vehicle.model}
                                </AppText>
                            </View>
                            <View
                                style={{
                                    borderWidth: 4,
                                    borderTopWidth: 0,
                                    borderColor: config.colors.tertiary,
                                    backgroundColor: config.colors.white,
                                    marginBottom: 10,
                                }}
                            >
                                {vehicle.bodyImage && (
                                    <Image style={{ width: 310, height: 200 }} source={{ uri: vehicle.bodyImage }} resizeMode="contain" />
                                )}
                            </View>
                            <View>
                                <TouchableOpacity
                                    style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        paddingLeft: 20,
                                        borderWidth: 4,
                                        borderColor: config.colors.regPlateBlue,
                                        backgroundColor: config.colors.regPlate,
                                    }}
                                    onPress={() => handleVehicleConfirmed()}
                                >
                                    <AppText style={{ fontFamily: "UKNumberPlate" }}>Confirm Vehicle</AppText>
                                    <Icon name="check" size={50} backgroundColor={config.colors.regPlate} iconColor={config.colors.regPlateBlue} />
                                </TouchableOpacity>
                            </View>
                        </View>
                    )}
                </View>
            </ScrollView>
            <FlatList
                key={window.width > 758 ? "h" : "v"}
                data={products && products}
                numColumns={window.width > 758 ? 3 : 1}
                keyExtractor={(item) => item._id}
                horizontal={false}
                showsVerticalScrollIndicator={false}
                renderItem={({ item }) => <ListingCard product={item} navigation={navigation} />}
            />
        </Screen>
    );
}

const styles = StyleSheet.create({
    screen: {
        flex: 1,
        flexDirection: "column",
        padding: 100,
    },
    body: {
        justifyContent: "center",
        flexDirection: "column",
    },
    logoContainer: {
        marginTop: 40,
        borderRadius: 25,
        alignItems: "center",
    },
    logo: {
        width: 300,
        height: 125,
    },
});

export default WelcomeScreen;
